import React, { useState, useEffect } from 'react'
import { Box, Button, Grid } from '@mui/material';
import ReportHeader from '../../../../common/ReportHeader';
import CustomDatePicker from '../../../../common/CustomDatePicker';
import { focusElemnt, formatDate, navigation1, navigation3 } from '../../../../../utilityFunctions';
import excelExport from '../../../../../assets/extra/export-excel';
import { excelConfig } from '../../../../../assets/extra/excelConfig';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { callAddFontRobotoBold } from '../../../../../assets/fonts/Roboto-bold';
import { callAddFontRobotoNormal } from '../../../../../assets/fonts/Roboto-normal';
import Alert from '../../../../common/Alert';
import moment from 'moment/moment';
import { getPGTransactionStatusReportData, getTransStatusList } from '../../../../../redux/KSRTC_Redux/ReportsPage/ReportsAction';
import { useDispatch, useSelector } from 'react-redux';
import { columnDefs } from './constants';
import { getTotalByKey, jsPdfDidParseCellCallback, jsPdfWillDrawCellCallback } from '../../../../generics/helper';
import { onlineReportMenu, reportMenu } from '../../../../../redux/Actions';
import PGTransactionStatusReportTable from './PGTransactionStatusReportTable';
import MultiSelectDropDown from '../../../../form-components/MultiSelectDropDownComponent';


const PGTransactionStatusReport = () => {
    const dispatch = useDispatch()
    const user = useSelector((store) => store.user);
    const yesterdayDate = new Date();
    yesterdayDate.setDate(yesterdayDate.getDate() - 1);
    const [selData, setSelData] = useState({
        fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
        toDate: formatDate(window.getTime ? window.getTime() : new Date()),
        transStatus: []
    });
    const [showAlert, setShowAlert] = useState(false);
    const [alertMsg, setAlertMsg] = useState("");
    const [transStatusList, setTransStatusList] = useState([]);

    const currentDateTime = moment().format('DD-MMM-YYYY HH:mm');

    const handleResetValue = () => {
        setSelData({
            fromDate: formatDate(window.getTime ? window.getTime() : new Date()),
            toDate: formatDate(window.getTime ? window.getTime() : new Date()),
            transStatus: transStatusList
        })
    }
    const [showReport, setShowReport] = useState(false)
    const [reportTableData, setReportTableData] = useState({})
    useEffect(() => {
        focusElemnt("transactionFromDate")
    }, [])
    useEffect(() => {
        fetchData();
    }, []);
    const fetchData = async () => {
        try {
            const body = { RefundStatusID: 0, }
            const res = await dispatch(getTransStatusList(body));
            if (res.status === 200 && res.data.status) {
                if (res.data?.Data?.Table?.length > 0) {
                    setTransStatusList(res.data.Data.Table);
                    setSelData(prevData => ({
                        ...prevData,
                        transStatus: res.data.Data.Table
                    }));
                }
            } else {
                console.error('Error: Invalid response status or data');
            }
        } catch (error) {
            console.error('Error fetching report data:', error);
        }
    };
    const handleAlert = (msg) => {
        setShowAlert(true)
        setAlertMsg(msg)
    }
    const printReport = async () => {
        if ((moment(selData?.toDate).startOf().diff(moment(selData?.fromDate).endOf(), 'days')) > 30) {
            handleAlert("This report cannot be taken for more than 31 days")
        } else {
            const body = {
                FromDate: selData?.fromDate,
                ToDate: selData?.toDate,
                RefStatusID: selData?.transStatus?.length === 1 ? selData?.transStatus[0]?.StatusID : 0
            }
            const res = await dispatch(getPGTransactionStatusReportData(body));
            if (res.status === 200 && res.data.status) {
                let reportData = [];
                if (res.data?.Data?.Table?.length > 0) {
                    const keys = ["TotalAmount",];
                    const totals = getTotalByKey(res.data?.Data?.Table, keys);
                    totals.SlNo = "GRAND TOTAL";
                    totals.isTotalRow = true;
                    reportData = res.data?.Data?.Table?.map((val, i) => ({ ...val, isDataRow: true, PGType: val.PGType === 'razorpay' ? 'Kotak Bank' : val.PGType, RefStatusLastUpdatedOn: val?.RefStatusLastUpdatedOn !== '' ? moment(val?.RefStatusLastUpdatedOn).format('DD-MMM-YYYY HH:mm:ss') : '' }));
                    reportData.push(totals);
                } else {
                    //handle error
                    handleAlert("NO Data Found")
                    return
                }
                try {
                    const pdfColumns = columnDefs.map((col) => {
                        return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
                    });


                    jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
                    jsPDF.API.events.push(["addFonts", callAddFontRobotoNormal]);
                    const doc = new jsPDF({
                        orientation: 'l',
                        format: [1182, 835],
                        compress: true,
                        unit: 'px'
                    });
                    var totalPagesExp = '{total_pages_count_string}';
                    doc.autoTableSetDefaults({
                        headStyles: { fontSize: 6, halign: 'left', fillColor: [30, 89, 167], },
                    });
                    const startY = 10;
                    doc.setFontSize(14);
                    doc.setTextColor("#000000");
                    doc.setFont('Roboto', 'bold');
                    var text1 = 'KARNATAKA STATE ROAD TRANSPORT CORPORATION';
                    var textWidth1 = doc.getStringUnitWidth(text1) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                    var centerX1 = (doc.internal.pageSize.width - textWidth1) / 2;
                    doc.text(text1, centerX1, startY);
                    doc.setFont('Roboto', 'normal');
                    doc.setFontSize(10);
                    doc.setTextColor("#000000");
                    var text2 = 'PG TRANSACTION STATUS';
                    var textWidth2 = doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                    var centerX2 = (doc.internal.pageSize.width - textWidth2) / 2;
                    doc.text(text2, centerX2, startY + 8);

                    doc.text(`From Date: ${moment(selData?.fromDate).format("DD-MMM-YYYY")}`, 5, startY + 16);
                    doc.text(`User : ${user?.UserName || ''} (${sessionStorage.getItem('LoginId') || ""})`, doc.internal.pageSize.width - 5, startY + 16, "right");

                    doc.text(`To Date: ${moment(selData?.toDate).format("DD-MMM-YYYY")}`, 5, startY + 24);
                    doc.text(`Print Date & Time : ${currentDateTime}`, doc.internal.pageSize.width - 5, startY + 24, "right");

                    // Print the table on the first page
                    autoTable(doc, {
                        startY: startY + 32,
                        margin: { top: 3, left: 5, right: 5, bottom: 3 },
                        tableWidth: 'auto',
                        columns: pdfColumns,
                        body: reportData,
                        columnStyles:
                        {
                            0: { halign: 'right', fontSize: 8, },
                            1: { halign: 'left', fontSize: 8, },
                            2: { halign: 'left', fontSize: 8, },
                            3: { halign: 'right', fontSize: 8, },
                            4: { halign: 'left', fontSize: 8, },
                            5: { halign: 'left', fontSize: 8, },
                            6: { halign: 'left', fontSize: 8, },
                            7: { halign: 'left', fontSize: 8, },
                            8: { halign: 'left', fontSize: 8, },
                            9: { halign: 'left', fontSize: 8, },
                            10: { halign: 'left', fontSize: 8, },
                            11: { halign: 'left', fontSize: 8, },
                            12: { halign: 'left', fontSize: 8, },
                            13: { halign: 'left', fontSize: 8, },
                            14: { halign: 'left', fontSize: 8, },
                            15: { halign: 'left', fontSize: 8, },
                            16: { halign: 'left', fontSize: 8, },
                            17: { halign: 'left', fontSize: 8, },
                        },
                        theme: 'grid',
                        headStyles: {
                            fillColor: null,
                            textColor: [0, 0, 0],
                            lineWidth: 0.2,
                            fontSize: 10
                        },
                        didParseCell: (data) => {
                            jsPdfDidParseCellCallback(data, pdfColumns, []);
                        },
                        willDrawCell: (data) => {
                            jsPdfWillDrawCellCallback(data, true);
                        },
                        didDrawPage: function (data) {
                            data.settings.margin.top = 16;
                        },
                        pageBreak: "auto"
                    });


                    // Add total pages if available
                    if (typeof doc.putTotalPages === 'function') {
                        doc.putTotalPages(totalPagesExp)
                    }




                    // Trigger download
                    const pdfData = doc.output('blob');
                    const pdfUrl = URL.createObjectURL(pdfData);
                    const link = document.createElement('a');
                    link.href = pdfUrl;
                    link.download = 'CANCEL_TRANSACTION_STATUS.pdf';
                    link.click();
                }
                catch (error) {
                    console.log("Error: ", error);
                }
            }
        }

    }
    const reportExcelExport = async () => {
        if ((moment(selData?.toDate).startOf().diff(moment(selData?.fromDate).endOf(), 'days')) > 30) {
            handleAlert("This report cannot be taken for more than 31 days")
        } else {
            try {
                const body = {
                    FromDate: selData?.fromDate,
                    ToDate: selData?.toDate,
                    RefStatusID: selData?.transStatus?.length === 1 ? selData?.transStatus[0]?.StatusID : 0
                }
                const res = await dispatch(getPGTransactionStatusReportData(body));
                if (res.status === 200 && res.data.status) {
                    let reportData = [];
                    if (res.data?.Data?.Table?.length > 0) {
                        const keys = ["TotalAmount",];
                        const totals = getTotalByKey(res.data?.Data?.Table, keys);
                        totals.totalCaption = "GRAND TOTAL";
                        totals.isTotalRow = true;
                        reportData = res.data?.Data?.Table?.map((val, i) => ({ ...val, isDataRow: true, PGType: val.PGType === 'razorpay' ? 'Kotak Bank' : val.PGType, RefStatusLastUpdatedOn: val?.RefStatusLastUpdatedOn !== '' ? moment(val?.RefStatusLastUpdatedOn).format('DD-MMM-YYYY HH:mm:ss') : '' }));
                        reportData.push(totals);
                    } else {
                        //handle error
                        handleAlert("NO Data Found")
                        return
                    }
                    const xlColumns = columnDefs.map((col) => {
                        return { colHeader: col.exportHead, field: col.field, xlCol: col.xlCol }
                    });

                    const xlConfig = {
                        ...excelConfig,
                        columns: xlColumns,
                        fileName: `CANCEL_TRANSACTION_STATUS_REPORT.xlsx`,
                        showFilterSection: true,
                        showSummarySection: true,
                        showEmptyRow: true,
                        headerRowStyle: { fill: '', bold: true },
                        borderStyle: {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        },
                        showHeader: true,
                        workSheetTitle: `CANCEL_TRANSACTION_STATUS_REPORT`,
                        headerFooter: {
                            firstHeader: "CANCEL_TRANSACTION_STATUS_REPORT",
                            firstFooter: "CANCEL_TRANSACTION_STATUS_REPORT"
                        },
                        sheetHeaderData: [
                            {
                                "caption": "KARNATAKA STATE ROAD TRANSPORT CORPORATION",
                                "colSpan": 18,
                                "horizontal": "center",
                                "newRow": true
                            },
                            {
                                "caption": "PG TRANSACTION STATUS",
                                "colSpan": 18,
                                "size": 12,
                                "horizontal": "center",
                                "newRow": true
                            },
                            {
                                "caption": "From Date:",
                                "value": `${moment(selData?.fromDate).format("DD-MMM-YYYY")}`,
                                "colSpan": 6,
                                "size": 10,
                            },
                            {
                                "caption": "",
                                "value": ``,
                                "colSpan": 1,
                            },
                            {
                                "caption": `User : `,
                                "value": `${user?.UserName || ''} (${sessionStorage.getItem('LoginId') || ""})`,
                                "colSpan": 11,
                                "horizontal": "right",
                                "size": 10,
                                "newRow": true
                            }, {
                                "caption": "To Date:",
                                "value": `${moment(selData?.toDate).format("DD-MMM-YYYY")}`,
                                "colSpan": 6,
                                "size": 10
                            },
                            {
                                "caption": "",
                                "value": ``,
                                "colSpan": 1,
                            },
                            {
                                "caption": "Print Date & Time : ",
                                "value": `${currentDateTime}`,
                                "colSpan": 11,
                                "horizontal": "right",
                                "size": 10
                            },
                        ],
                    };
                    await excelExport.processExcel(xlConfig, reportData)
                } else {
                    handleAlert(res.data?.Message);
                }
            } catch (err) {
                console.log(err);

            }
        }
    }
    const transStatusProps = () => {
        return {
            id: 'transStatus',
            width: "100%",
            name: "transStatus",
            label: "",
            isCompulsory: false,
            options: transStatusList || [],
            preSelectedValues: selData?.transStatus,
            searchPlaceholder: "Search by Transaction Status",
            disabled: false,
            isObject: true,
            primaryKey: 'StatusID',
            labelKey: 'StatusName',
            singleSelect: true,
            selectAllOption: true,
            defaultAllSelected: true,
            prevId: "withdrawaldate",
            nextId: "servicetype",
        }
    }
    const handleSumbit = async () => {
        setShowReport(false)
        setReportTableData({})
        if ((moment(selData?.toDate).startOf().diff(moment(selData?.fromDate).endOf(), 'days')) > 30) {
            handleAlert("This report cannot be taken for more than 31 days")
        } else {
            const headerData = {
                fromDate: selData?.fromDate,
                toDate: selData?.toDate,
                transStatus: selData?.transStatus
            };
            const body = {
                FromDate: selData?.fromDate,
                ToDate: selData?.toDate,
                RefStatusID: selData?.transStatus?.length === 1 ? selData?.transStatus[0]?.StatusID : 0
            }
            dispatch(getPGTransactionStatusReportData(body)).then((res) => {
                if (res?.status === 200 && res?.data?.status) {
                    if (res?.data?.Data?.Table?.length > 0) {
                        let newData = res?.data?.Data?.Table?.map((item) => ({
                            ...item,
                            PGType: item.PGType === 'razorpay' ? 'Kotak Bank' : item.PGType
                        }))
                        setShowReport(true)
                        setReportTableData({ header: headerData, TableData: newData })
                    } else {
                        //handle error
                        handleAlert("NO Data Found")
                        setShowReport(false)
                        setReportTableData({ header: headerData, TableData: [] })
                    }
                    setTimeout(() => {
                        focusElemnt('BackBtn')
                    }, 200)
                } else {
                    handleAlert(res.data?.Message);
                }
            })
        }
    }
    return (
        <>
            {!showReport ?
                <Box>
                    {/* {!showReport && */}
                    <>
                        <ReportHeader mainHeaderName='Report' headerName='Online Report' openSubMenu={() => dispatch(reportMenu(true))} subHeader={'PG Transaction Status'} subHeaderVisible={() => dispatch(onlineReportMenu(true))} mainMenuOpen={true} />
                        <Grid
                            container
                            spacing={0}
                            className="column-container"
                            style={{
                                padding: "16px 16px 58px 16px",
                            }}
                        >
                            <Grid item md={6.5}
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '16px'
                                }}
                            >

                                <Grid
                                    container
                                    direction='row'
                                    style={{
                                        paddingRight: '30px'
                                    }}
                                >
                                    <Grid item md={4}> From Date </Grid>
                                    <Grid item md={8}>
                                        <CustomDatePicker
                                            selectedDate={selData?.fromDate}
                                            onChange={(value) => {
                                                setSelData((prev) => ({
                                                    ...prev,
                                                    fromDate: formatDate(value),
                                                    toDate: formatDate(value)
                                                }))
                                            }}
                                            minDate={'2024-06-19'}
                                            maxDate={formatDate(window.getTime ? window.getTime() : new Date())}
                                            //maxDate={formatDate(yesterdayDate)}
                                            id={`transactionFromDate`}
                                            onKeyDown={(e) => {
                                                navigation1(e, "transactionToDate", "");
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction='row'
                                    style={{
                                        paddingRight: '30px'
                                    }}
                                >
                                    <Grid item md={4}> To Date </Grid>
                                    <Grid item md={8}>
                                        <CustomDatePicker
                                            selectedDate={selData?.toDate}
                                            onChange={(value) => {
                                                setSelData((prev) => ({
                                                    ...prev,
                                                    toDate: formatDate(value)
                                                }));
                                            }}
                                            minDate={selData?.fromDate}
                                            maxDate={formatDate(window.getTime ? window.getTime() : new Date())}
                                            //maxDate={formatDate(yesterdayDate)}
                                            id={`transactionToDate`}
                                            onKeyDown={(e) => {
                                                navigation1(e, "SubmitBtn", "transactionFromDate");
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction='row'
                                    style={{
                                        paddingRight: '30px'
                                    }}
                                >
                                    <Grid item md={4}>Transaction Status</Grid>
                                    <Grid item md={8}>
                                        <MultiSelectDropDown id="travelType"
                                            {...transStatusProps()}
                                            onSelect={(val) => {
                                                setSelData((prev) => ({
                                                    ...prev,
                                                    transStatus: val
                                                }))
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid
                                    container
                                    direction='row'
                                    style={{
                                        paddingRight: '30px',
                                        gap: '10px',
                                        flexWrap: 'nowrap'
                                    }}
                                >
                                    <Grid item md={4}></Grid>
                                    <Grid item md={2}>
                                        <Button variant="contained" size="medium"
                                            className={`btn-orange`}
                                            id='SubmitBtn'
                                            onKeyDown={(e) => navigation3(e, "PDFBtn", "transactionToDate", () => { })}
                                            onClick={() => handleSumbit()}
                                        >
                                            Submit
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            variant="outlined"
                                            size="medium"
                                            className="btn-orange-outline"
                                            onClick={() => printReport()}
                                            id='PDFBtn'
                                            onKeyDown={(e) => navigation3(e, "ExcelBtn", "SubmitBtn", () => { })}
                                        >
                                            PDF
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            variant="outlined"
                                            size="medium"
                                            className="btn-orange-outline"
                                            onClick={reportExcelExport}
                                            id='ExcelBtn'
                                            onKeyDown={(e) => navigation3(e, "ResetBtn", "PDFBtn", () => { })}
                                        >
                                            EXCEL
                                        </Button>
                                    </Grid>
                                    <Grid item md={2}>
                                        <Button
                                            variant="outlined"
                                            size="medium"
                                            className="btn-orange-outline"
                                            onClick={() => handleResetValue()}
                                            id='ResetBtn'
                                            onKeyDown={(e) => navigation3(e, "BackBtn", "ExcelBtn", () => { })}
                                        >
                                            RESET
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                </Box>
                :
                <PGTransactionStatusReportTable reportTableData={reportTableData} handleBack={() => {
                    setShowReport(false)
                    setReportTableData({})
                }} />
            }
            {showAlert && (
                <Alert
                    msg={alertMsg} alertType={"error"} close={() => setShowAlert(false)} buttonText="Ok"
                />
            )}
        </>
    )
}

export default PGTransactionStatusReport
